import React, { useState } from 'react';
import { Box, Button, Typography, Modal } from '@mui/material';
import SearchableDropdown from "../../../FlowBuilder/Common/SearchableDropdown/SearchableDropdown.tsx";
import OrganisationDropdown from '../../../Shared/OrganisationDropdown/index.tsx';
import { CatagoryTypes } from '../../../../constants.js';
import { validateMappingForm } from '../../validations.ts';

interface MappinModalProps {
    open: boolean;
    onClose: (result: any | null) => void;
}

const MappinModal: React.FC<MappinModalProps> = ({ open, onClose }) => {
    const [formData, setFormData] = useState<any>({ firstCategory: null, firstOrganisation: null, secondOrganisation: null, secondCategory: null });
    const [errors, setErrors] = useState<any>({});
    const handleCreate = () => {
        let result = validateMappingForm(formData);
        setErrors(result);
        if (Object.keys(result).length === 0) {
            onClose(formData);
        }
    };

    return (
        <Modal open={open} onClose={() => onClose(null)}>
            <Box
                sx={{
                    position: 'absolute',
                    top: '40%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    borderRadius: '8px',
                    p: 3,
                    width: 600,
                    maxHeight: '300vh',
                    overflowY: 'auto',
                }}
            >
                <Typography variant="h6" fontWeight="bold" gutterBottom>
                    Create New Organisation Mapping
                </Typography>

                <Box mb={3}>
                    <SearchableDropdown
                        label="Select Source Category"
                        options={CatagoryTypes}
                        value={formData?.firstCategory}
                        onChange={(e) => setFormData({ ...formData, firstCategory: e })}
                    />
                </Box>
                <Box mb={3}>
                    <OrganisationDropdown
                        label={
                            <Typography component="span">
                                Select Source Organisation <span style={{ color: 'red' }}>*</span>
                            </Typography>
                        }
                        value={formData?.firstOrganisation}
                        onChange={(e) => setFormData({ ...formData, firstOrganisation: e })}
                        categoryType={formData?.firstCategory?.value || ''}
                        error={!!errors?.firstOrganisation}
                        errorMessage={errors?.firstOrganisation}

                    />
                </Box>
                <Box mb={3}>
                    <SearchableDropdown
                        label="Select Category You Want To Work With"
                        options={CatagoryTypes}
                        value={formData?.secondCategory}
                        onChange={(e) => setFormData({ ...formData, secondCategory: e })}
                    />
                </Box>
                <Box mb={3}>
                    <OrganisationDropdown
                        label={
                            <Typography component="span">
                                Select Organization <span style={{ color: 'red' }}>*</span>
                            </Typography>
                        }
                        value={formData?.secondOrganisation}
                        onChange={(e) => setFormData({ ...formData, secondOrganisation: e })}
                        categoryType={formData?.secondCategory?.value || ''}
                        error={!!errors?.secondOrganisation}
                        errorMessage={errors?.secondOrganisation}
                    />
                </Box>
                <Box mt={3} display="flex" justifyContent="flex-end" gap={2}>
                    <Button variant="outlined" onClick={() => onClose(null)} size="small">
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        onClick={handleCreate}
                        color="primary"
                        size="small"
                    >
                        Create
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
};

export default MappinModal;
